import React from "react";
import PropTypes from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { useI18n } from "../../i18n/useI18n";
import negativeEmptyState from "../../assets/empty-state-negative.svg";
import css from "./MFEUnavailableState.less";

const [HbrIcon] = reactWrapper(["hbr-icon"]);

export const MFE_UNAVAILABLE_COMPONENT_NAMES = Object.freeze({
  applications: "mfeApplicationsName",
  application360: "mfeApplication360Name",
  circuits: "mfeCircuitName",
  circuit360: "mfeCircuit360Name",
  threat_intelligence: "mfeThreatIntelligenceName",
  trafficLogs: "mfeTrafficLogsName",
  optimization: "mfeOptimizationName",
  appQoeDetails: "mfeApplicationQoeDetailsName",
  bandwidthForecast: "mfeBandwidthForecastName",
  c3Header: "mfeC3HeaderName",
  SdwanGlobalSearchComponent: "mfeGlobalSearchName",
  aiCanvasLauncher: "mfeAiCanvasName",
});

const getComponentNameKey = componentId =>
  MFE_UNAVAILABLE_COMPONENT_NAMES[componentId?.split("/").pop()];

const MFEUnavailableState = ({ componentId, title, description, display }) => {
  const { tCommon } = useI18n("common");
  const componentNameKey = getComponentNameKey(componentId);
  const componentName = componentNameKey ? tCommon(componentNameKey) : "";
  const isPageState = display !== "inline" && componentName;
  const componentTitle = componentName
    ? tCommon("mfeComponentUnavailableTitle", { component: componentName })
    : tCommon("mfeUnavailableTitle");
  const componentDescription = isPageState
    ? tCommon("mfePageContentUnavailableDescription", { page: componentName })
    : tCommon("mfeUnavailableDescription");
  const displayTitle = title || (
    isPageState
      ? tCommon("mfePageContentUnavailableTitle", { page: componentName })
      : componentTitle
  );
  const displayDescription = description || componentDescription;

  if (display === "inline") {
    return (
      <div
        className={css["mfe-unavailable-inline"]}
        data-testid="mfe-unavailable-inline"
        role="status"
        aria-live="polite"
      >
        <HbrIcon
          aria-hidden="true"
          name="hbr-error-filled"
          sentiment="danger"
          size="16px"
        />
        <span>{displayTitle}</span>
      </div>
    );
  }

  return (
    <section
      className={css["mfe-unavailable-state"]}
      data-testid="mfe-unavailable-state"
      role="status"
      aria-live="polite"
    >
      <img src={negativeEmptyState} alt="" aria-hidden="true" />
      <h2>{displayTitle}</h2>
      <p>{displayDescription}</p>
    </section>
  );
};

MFEUnavailableState.propTypes = {
  componentId: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  display: PropTypes.oneOf(["inline", "full"]),
};

MFEUnavailableState.defaultProps = {
  componentId: "",
  title: "",
  description: "",
  display: "full",
};

export default MFEUnavailableState;
